export enum SpeakerPanelEventsEnum {
  RESIZE_PRESENTATION_WINDOW = 'RESIZE_PRESENTATION_WINDOW',
  UPDATE_ANIMATION_SETTINGS = 'UPDATE_ANIMATION_SETTINGS',
  SEND_UPDATED_ANIMATION_SETTINGS = 'SEND_UPDATED_ANIMATION_SETTINGS',
  TOGGLE_SPEAKER_VIEW_SCREEN_SHARE = 'TOGGLE_SPEAKER_VIEW_SCREEN_SHARE',
  RENDERER_TO_MAIN_OPEN_SPEAKER_PANEL = 'RENDERER_TO_MAIN_OPEN_SPEAKER_PANEL',
  RENDERER_TO_MAIN_SET_SPEAKER_PANEL_DATA = 'RENDERER_TO_MAIN_SET_SPEAKER_PANEL_DATA',
  RENDERER_TO_MAIN_GET_SPEAKER_PANEL_DATA = 'RENDERER_TO_MAIN_GET_SPEAKER_PANEL_DATA',
  RENDERER_TO_MAIN_UPDATE_SPEAKER_PANEL_DATA = 'RENDERER_TO_MAIN_UPDATE_SPEAKER_PANEL_DATA',
  RENDERER_TO_MAIN_REMOVE_SPEAKER_PANEL_DATA = 'RENDERER_TO_MAIN_REMOVE_SPEAKER_PANEL_DATA',
  MAIN_TO_RENDERER_SPEAKER_PANEL_SET_ACTIVE_ITEM = 'MAIN_TO_RENDERER_SPEAKER_PANEL_SET_ACTIVE_ITEM',
  RENDERER_TO_MAIN_SPEAKER_PANEL_SET_ACTIVE_ITEM = 'RENDERER_TO_MAIN_SPEAKER_PANEL_SET_ACTIVE_ITEM',
  MAIN_TO_RENDERER_SPEAKER_PANEL_DETACH = 'MAIN_TO_RENDERER_SPEAKER_PANEL_DETACH',
  RENDERER_TO_MAIN_SPEAKER_PANEL_DETACH = 'RENDERER_TO_MAIN_SPEAKER_PANEL_DETACH',
  RENDERER_TO_MAIN_CLOSE_SPEAKER_PANEL = 'RENDERER_TO_MAIN_CLOSE_SPEAKER_PANEL',
  RENDERER_TO_MAIN_CLOSE_FROM_SPEAKER_PANEL = 'RENDERER_TO_MAIN_CLOSE_FROM_SPEAKER_PANEL',
  RENDERER_TO_MAIN_RESET_SPEAKER_PANEL_DATA = 'RENDERER_TO_MAIN_RESET_SPEAKER_PANEL_DATA',
  MAIN_TO_SPEAKER_PANEL_CLOSE_FROM_SPEAKER_PANEL = 'MAIN_TO_SPEAKER_PANEL_CLOSE_FROM_SPEAKER_PANEL',
  MAIN_TO_SPEAKER_PANEL_UPDATED_DATA = 'MAIN_TO_SPEAKER_PANEL_UPDATED_DATA',
  RENDERER_TO_MAIN_SET_TOGGLE_BUTTON_STATE = 'RENDERER_TO_MAIN_SET_TOGGLE_BUTTON_STATE',
  MAIN_TO_RENDERER_SET_TOGGLE_BUTTON_STATE = 'MAIN_TO_RENDERER_SET_TOGGLE_BUTTON_STATE',
  MAIN_TO_SPEAKER_PANEL_REINITIALIZE = 'MAIN_TO_SPEAKER_PANEL_REINITIALIZE',
  MAIN_TO_SPEAKER_PANEL_SWITCH_WITH_KEYBOARD_SHORTCUT = 'MAIN_TO_SPEAKER_PANEL_SWITCH_WITH_KEYBOARD_SHORTCUT',
}
